import Cookies from "js-cookie";

const COOKIE_TOKEN = "c3crm";

// Get token from cookies
export const getToken = () => Cookies.get(COOKIE_TOKEN) || null;

// Store token in cookies securely
export const setToken = (token) => {
  Cookies.set(COOKIE_TOKEN, token, { secure: true, sameSite: "Strict" });
};

// Remove token from cookies
export const clearToken = () => {
  Cookies.remove(COOKIE_TOKEN);
};

// Check if user is authenticated
export const isAuthenticated = () => !!getToken();
